export default __webpack_public_path__ + "static/logo-adidas-b15aed3a861c43bb8e2f04ffdaaf7d14.png";